import loadable from '@loadable/component';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const PostSearchPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "PostSearchPageContainer" */
      './PostSearchPageContainer.dynamic'
    ),
  { fallback: <LoadableLoadingSection /> },
);
